module.exports = __webpack_public_path__ + "static/media/5d5c56c3-aa81-477b-9b47-77b5cf102a3f.1954d9c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/5d5c56c3-aa81-477b-9b47-77b5cf102a3f.jpg
// module id = 820
// module chunks = 0